import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import dayjs from 'dayjs';
import { FieldUsageSelector } from '@ui/tags/FieldUsageSelector';
import { InlineMetadata } from '@periscopes/general/metadata';
import React from 'react';
import { When } from 'react-if';
import { ComplianceCategorySelector, DataSensitivitySelector } from '@ui/tags';
import { GoToDictionaryButton, InformationSection, IngestedBySection, PopulatedBySection } from '@periscopes/general';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SalesforceDescription, SalesforceHelpText, SonarText } from '@ui/text';
import { usePeriscopeMetadata, useSonarObjectReference } from '@hooks';
export const FieldInformation = ({ sonarObjectId }) => {
    const { parentSonarObjectId } = useSonarObjectReference(sonarObjectId);
    const { metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceField);
    return (React.createElement(InformationSection, { headerAction: React.createElement(GoToDictionaryButton, { sonarObjectId: parentSonarObjectId }), sonarObjectId: sonarObjectId },
        React.createElement(SalesforceDescription, { sonarObjectId: sonarObjectId }),
        React.createElement(SalesforceHelpText, { sonarObjectId: sonarObjectId }),
        React.createElement(InlineMetadata, { headerSpaceAlign: 'start', label: COPY_SPECIFIC.COMPLIANCE_CATEGORY },
            React.createElement(ComplianceCategorySelector, { direction: 'horizontal', sonarObjectId: sonarObjectId })),
        React.createElement(InlineMetadata, { label: COPY_SPECIFIC.DATA_SENSITIVITY },
            React.createElement(DataSensitivitySelector, { sonarObjectId: sonarObjectId })),
        React.createElement(InlineMetadata, { label: COPY_SPECIFIC.FIELD_USAGE },
            React.createElement(FieldUsageSelector, { sonarObjectId: sonarObjectId })),
        React.createElement(IngestedBySection, { sonarObjectId: sonarObjectId }),
        React.createElement(PopulatedBySection, { sonarObjectId: sonarObjectId }),
        React.createElement(When, { condition: Boolean(metadata === null || metadata === void 0 ? void 0 : metadata.populationPercentageLastAnalyzed) },
            React.createElement(InlineMetadata, { label: COPY_SPECIFIC.POPULATION_PERCENT_LAST_ANALYZED },
                React.createElement(SonarText, null, dayjs(metadata === null || metadata === void 0 ? void 0 : metadata.populationPercentageLastAnalyzed).format('L'))))));
};
